<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox">
    <g :fill="iconColor" fill-rule="evenodd" :stroke="iconColor">
      <path
        d="M7.655 11.515a.466.466 0 0 0 .69 0l3.208-3.556a.433.433 0 0 0 .073-.476.458.458 0 0 0-.418-.26H9.375V1.443A.452.452 0 0 0 8.917 1H7.083c-.253 0-.458.2-.458.444v5.778H4.792a.46.46 0 0 0-.417.26.433.433 0 0 0 .072.477l3.208 3.556z"
      />
      <path d="M13.133 11v2.8H2.867V11H1v3.733c0 .516.418.934.933.934h12.134a.932.932 0 0 0 .933-.934V11h-1.867z" />
    </g>
  </svg>
</template>
<script>
  export default {
    name: 'icon-load',
    props: {
      width: {
        type: [Number, String],
        default: 16
      },
      height: {
        type: [Number, String],
        default: 17
      },
      viewBox: {
        type: String,
        default: '0 0 16 17'
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      },
      stroke: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
